import styled from 'styled-components';

export const _Label = styled.label`
  font-family: ${(props) => props.theme.fontFamilySecondary};
  font-weight: 400;
  color: ${(props) => props.theme.black};
  margin-bottom: 8px;
  display: block;
  box-sizing: border-box;
  float: none; // Scensum override
  text-transform: none;

  /* Remove margin bottom if label is the sibling of a checkbox or radio input */
  input[type='checkbox'] + &,
  input[type='radio'] + & {
    margin-bottom: 0;
  }
`;
